const data = [{
    id: 1,
    title: "官方视频",
    list: [{
        id: 2,
        cover: require('@/assets/images/video_page/video_img01/cz.png'),
        source: 'https://coresource.zhanhuo.com/video/crossout_bj/CG2.mp4',
        desc: '《创世战车》官方宣传PV',
        author: '《创世战车》运营团队',
        release_time: '2022-09-21',
      },
      {
        id: 3,
        cover: require('@/assets/images/video_page/video_img01/dd.png'),
        source: 'https://coresource.zhanhuo.com/video/crossout_bj/daodan.mp4',
        desc: '《创世战车》导弹武器展示',
        author: '《创世战车》运营团队',
        release_time: '2022-09-21',
      },
      {
        id: 4,
        cover: require('@/assets/images/video_page/video_img01/jzsq.png'),
        source: 'https://coresource.zhanhuo.com/video/crossout_bj/jinzhan.mp4',
        desc: '《创世战车》近身武器展示',
        author: '《创世战车》运营团队',
        release_time: '2022-09-21',
      },
      {
        id: 5,
        cover: require('@/assets/images/video_page/video_img01/kv.png'),
        source: 'https://coresource.zhanhuo.com/video/crossout_bj/xuanfu.mp4',
        desc: '《创世战车》模式展示',
        author: '《创世战车》运营团队',
        release_time: '2022-09-21',
      },
      {
        id: 10,
        cover: require('@/assets/images/video_page/video_img01/cjsdjhhcx00210cc.jpg'),
        source: 'https://coresource.zhanhuo.com/video/crossout_bj/cg2.mp4',
        desc: '创造，操纵，破坏！沙盒创造战车对战网游《创世战车》CG来袭！',
        author: '《创世战车》运营团队',
        release_time: '2022-10-21',
      },
      {
        id: 11,
        cover: require('@/assets/images/video_page/video_img01/kolasdkjjasljasd222.jpg'),
        source: 'https://coresource.zhanhuo.com/video/crossout_bj/chaoshou01.mp4',
        desc: '《创世战车》焕新测试宣传片曝光！全民造车，撞出快乐！',
        author: '《创世战车》运营团队',
        release_time: '2022-10-21',
      },
      {
        id: 12,
        cover: require('@/assets/images/video_page/video_img01/569643561356asmasjas.jpg'),
        source: 'https://coresource.zhanhuo.com/video/crossout_bj/wanfa6.mp4',
        desc: '《创世战车》玩法部分集锦，30种趣味玩法等你体验！',
        author: '《创世战车》运营团队',
        release_time: '2022-10-21',
      },
      {
        id: 13,
        cover: require('@/assets/images/video_page/video_img01/kajkasjas1221212.jpg'),
        source: 'https://coresource.zhanhuo.com/video/crossout_bj/cheku2.mp4',
        desc: '《创世战车》焕新测试即将来袭！趣味车库赏析~',
        author: '《创世战车》运营团队',
        release_time: '2022-10-21',
      },
      {
        id: 14,
        cover: require('@/assets/images/video_page/video_img01/kajskjasa232562.jpg'),
        source: 'https://coresource.zhanhuo.com/video/crossout_bj/ditu1.mp4',
        desc: '《创世战车》地图漫游开启，等你亲临~',
        author: '《创世战车》运营团队',
        release_time: '2022-10-21',
      },
      {
        id: 15,
        cover: require('@/assets/images/video_page/video_img01/alksaijsx223.jpg'),
        source: 'https://coresource.zhanhuo.com/video/crossout_bj/dazhuizhu2.mp4',
        desc: '《创世战车》追击模式！',
        author: '《创世战车》运营团队',
        release_time: '2022-10-21',
      },
      {
        id: 16,
        cover: require('@/assets/images/video_page/video_img01/lQDPJxtemGwypH_155.jpg'),
        source: 'https://coresource.zhanhuo.com/video/crossout_bj/xinlao-hb.mp4',
        desc: '《创世战车》画质全面升级，焕新测试定档1月13日！',
        author: '《创世战车》运营团队',
        release_time: '2023-01-13',
      },
      {
        id: 17,
        cover: require('@/assets/images/video_page/video_img01/lQDPJxnyzCxQcP_155.jpg'),
        source: 'https://coresource.zhanhuo.com/video/crossout_bj/wanfa_cbt.mp4',
        desc: '《创世战车》焕新测试正式开启！游戏玩法宣传片公布！',
        author: '《创世战车》运营团队',
        release_time: '2023-01-13',
      },
      {
        id: 18,
        cover: require('@/assets/images/video_page/video_img01/Ody7zHAPx97fagFcA_340_220.png'),
        source: 'https://coresource.zhanhuo.com/video/crossout_bj/TOP14K.mp4',
        desc: '燃擎公测宣传片',
        author: '《创世战车》运营团队',
        release_time: '2023-03-01',
      },
      {
        id: 19,
        cover: 'https://statics.kongzhong.com/co/2023/04/202304110956210282.jpg',
        source: 'https://statics.kongzhong.com/co/2023/04/202304110956327798.mp4',
        desc: '战车起飞，激战于教堂之上！',
        author: '《创世战车》运营团队',
        release_time: '2023-04-10',
      },
      {
        id: 20,
        cover: 'https://statics.kongzhong.com/co/2023/04/202304121036575819.png',
        source: 'https://statics.kongzhong.com/co/2023/04/202304121030280432.mp4',
        desc: '突破维度，空战来袭！',
        author: '《创世战车》运营团队',
        release_time: '2023-04-12',
      },
      {
        id: 21,
        cover: 'https://statics.kongzhong.com/co/2023/04/202304141005056463.jpg',
        source: 'https://statics.kongzhong.com/co/2023/04/202304141005540478.mp4',
        desc: '全新通行证活动"审判之夜"',
        author: '《创世战车》运营团队',
        release_time: '2023-04-14',
      },
      {
        id: 22,
        cover: 'https://statics.kongzhong.com/co/2023/04/202304141848018941.png',
        source: 'https://statics.kongzhong.com/co/2023/04/202304141848306771.mp4',
        desc: '问让战车飞起来需要几步？',
        author: '《创世战车》运营团队',
        release_time: '2023-04-14',
      },
      {
        id: 23,
        cover: 'https://statics.kongzhong.com/co/2023/05/202305171539309965.jpg',
        source: 'https://statics.kongzhong.com/co/2023/05/202305171539463623.mp4',
        desc: '夏日狂欢节版本抢先看',
        author: '《创世战车》运营团队',
        release_time: '2023-05-17',
      },
      {
        id: 24,
        cover: 'https://statics.kongzhong.com/co/2023/05/202305181805087245.jpg',
        source: 'https://statics.kongzhong.com/co/2023/05/202305181805237928.mp4',
        desc: '夏季大乱斗宣传视频',
        author: '《创世战车》运营团队',
        release_time: '2023-05-18',
      },
      {
        id: 25,
        cover: 'https://statics.kongzhong.com/co/2023/05/202305181805080968.jpg',
        source: 'https://statics.kongzhong.com/co/2023/05/202305181805253141.mp4',
        desc: '夏日庆典宣传视频',
        author: '《创世战车》运营团队',
        release_time: '2023-05-18',
      },
      {
        id: 26,
        cover: 'https://statics.kongzhong.com/co/2023/06/202306161427010957.png',
        source: 'https://statics.kongzhong.com/co/2023/06/202306161427245372.mp4',
        desc: '《奇点计划》宣传视频',
        author: '《创世战车》运营团队',
        release_time: '2023-06-16',
      },
      {
        id: 27,
        cover: 'https://statics.kongzhong.com/co/2023/06/202306161427011222.png',
        source: 'https://statics.kongzhong.com/co/2023/06/202306161427259933.mp4',
        desc: '全新地图：轨道站',
        author: '《创世战车》运营团队',
        release_time: '2023-06-16',
      },
      {
        id: 28,
        cover: 'https://statics.kongzhong.com/co/2023/06/202306301726336021.jpg',
        source: 'https://statics.kongzhong.com/co/2023/06/202306301725475718.mp4',
        desc: '"红灯"行动现已上线',
        author: '《创世战车》运营团队',
        release_time: '2023-06-30',
      },
      {
        id: 29,
        cover: 'https://statics.kongzhong.com/co/2023/07/202307201010439916.jpg',
        source: 'https://statics.kongzhong.com/co/2023/07/202307201011079813.mp4',
        desc: '狐之宝藏版本抢先看',
        author: '《创世战车》运营团队',
        release_time: '2023-07-20',
      },
      {
        id: 30,
        cover: 'https://statics.kongzhong.com/co/2023/07/202307211109265826.jpg',
        source: 'https://statics.kongzhong.com/co/2023/07/202307211109370489.mp4',
        desc: '地图变化-古堡遗迹',
        author: '《创世战车》运营团队',
        release_time: '2023-07-21',
      },
      {
        id: 31,
        cover: 'https://coresource.zhanhuo.com/image/2.10/ygfm.png',
        source: 'https://coresource.zhanhuo.com/video/2.10/skyriderBBYG.mp4',
        desc: '“天空行动”版本预告',
        author: '《创世战车》运营团队',
        release_time: '2023-10-16',
      },
      {
        id: 32,
        cover: 'https://coresource.zhanhuo.com/image/2.10/quanxinditu2.png',
        source: 'https://coresource.zhanhuo.com/video/2.10/newPVPmap.mp4',
        desc: '“天空行动”四张全新PVP地图',
        author: '《创世战车》运营团队',
        release_time: '2023-10-17',
      },
      {
        id: 33,
        cover: 'https://coresource.zhanhuo.com/image/2.10/qiangxiankan.jpg',
        source: 'https://coresource.zhanhuo.com/video/2.10/skyriderqiangxiankan.mp4',
        desc: '“天空行动”版本抢先看',
        author: '《创世战车》运营团队',
        release_time: '2023-10-18',
      },
      {
        id: 34,
        cover: 'https://coresource.zhanhuo.com/image/2.10/xuanchuanfengmian.jpg',
        source: 'https://coresource.zhanhuo.com/video/2.10/CO-skyrider-xuanchuanpian.mp4',
        desc: '“天空行动”版本宣传片',
        author: '《创世战车》运营团队',
        release_time: '2023-10-19',
      },
      {
        id: 35,
        cover: 'https://coresource.zhanhuo.com/image/2.10/factionwar.jpg',
        source: 'https://coresource.zhanhuo.com/video/2.10/factionwar.mp4',
        desc: '阵营战争已经打响',
        author: '《创世战车》运营团队',
        release_time: '2023-10-23',
      },
      {
        id: 36,
        cover: 'https://coresource.zhanhuo.com/image/2.11/fengmian211.png',
        source: 'https://coresource.zhanhuo.com/video/2.11/jixiejueqi.mp4',
        desc: '新版本「机械崛起」将于12月22日上线',
        author: '《创世战车》运营团队',
        release_time: '2023-12-20',
      },
      {
        id: 37,
        cover: 'https://coresource.zhanhuo.com/image/2.12/cozhounian.jpg',
        source: 'https://coresource.zhanhuo.com/video/2.12/cozhounian.mp4',
        desc: '一路同行 战起新篇《创世战车》一周年啦！',
        author: '《创世战车》运营团队',
        release_time: '2024-03-01',
      },
      {
        id: 38,
        cover: 'https://coresource.zhanhuo.com/image/2.13/fenmian.jpg',
        source: 'https://coresource.zhanhuo.com/video/2.13/banben.mp4',
        desc: '战潮涌动！新版本「隐秘威胁」将于3月31日上线',
        author: '《创世战车》运营团队',
        release_time: '2024-03-29',
      },
      {
        id: 39,
        cover: 'https://coresource.zhanhuo.com/image/2.14/214pv.png',
        source: 'https://coresource.zhanhuo.com/video/2.14/214pv.mp4',
        desc: '《创世战车》全新版本“预兆显现”现已到来！',
        author: '《创世战车》运营团队',
        release_time: '2024-04-25',
      },
      {
        id: 40,
        cover: 'https://coresource.zhanhuo.com/image/2.15/pv.png',
        source: 'https://coresource.zhanhuo.com/video/2.15/pv.mp4',
        desc: '狂暴一战，一触即发！【疯狂追逐】新版本即将开启！！',
        author: '《创世战车》运营团队',
        release_time: '2024-05-30',
      },
      {
        id: 41,
        cover: 'https://coresource.zhanhuo.com/image/2.16/pv.png',
        source: 'https://coresource.zhanhuo.com/video/2.16/pv.mp4',
        desc: '【创世战车】“机械飞升”全新赛季预告片',
        author: '《创世战车》运营团队',
        release_time: '2024-06-14',
      },
      {
        id: 42,
        cover: 'https://coresource.zhanhuo.com/image/2.16/pv2.png',
        source: 'https://coresource.zhanhuo.com/video/2.16/pv2.mp4',
        desc: '【创世战车】全新赛季[机械飞升]版本内容抢先看！',
        author: '《创世战车》运营团队',
        release_time: '2024-06-20',
      },
      {
        id: 43,
        cover: 'https://coresource.zhanhuo.com/image/2.16/216jiaoxue.png',
        source: 'https://coresource.zhanhuo.com/video/2.16/216jiaoxue.mp4',
        desc: '【创世战车】新赛季[机械飞升]全新部件攻略分享！',
        author: '《创世战车》运营团队',
        release_time: '2024-06-26',
      },
      {
        id: 44,
        cover: 'https://coresource.zhanhuo.com/image/2.16/jiaoxue.png',
        source: 'https://coresource.zhanhuo.com/video/2.16/jiaoxue.mp4',
        desc: '保姆教学第一期【创世战车】基础造车攻略',
        author: '《创世战车》运营团队',
        release_time: '2024-07-04',
      },
      {
        id: 45,
        cover: 'https://coresource.zhanhuo.com/image/2.16/jiaoxue2.png',
        source: 'https://coresource.zhanhuo.com/video/2.16/jiaoxue2.mp4',
        desc: '保姆教学第二期【创世战车】基础造车攻略进阶版',
        author: '《创世战车》运营团队',
        release_time: '2024-07-15',
      },
      {
        id: 45,
        cover: 'https://coresource.zhanhuo.com/image/2.17/jiaoxue3.png',
        source: 'https://coresource.zhanhuo.com/video/2.17/jiaoxue3.mp4',
        desc: '【入门攻略】机械腿类移动装置造车指南',
        author: '《创世战车》运营团队',
        release_time: '2024-07-19',
      },
      {
        id: 46,
        cover: 'https://coresource.zhanhuo.com/image/2.17/pv.png',
        source: 'https://coresource.zhanhuo.com/video/2.17/pv.mp4',
        desc: '《创世战车》全新版本“废土夺宝”',
        author: '《创世战车》运营团队',
        release_time: '2024-07-25',
      },
      {
        id: 47,
        cover: 'https://coresource.zhanhuo.com/image/2.17/wuqi.png',
        source: 'https://coresource.zhanhuo.com/video/2.17/wuqi.mp4',
        desc: '【创世战车】全新的遗迹级武器“吞噬者”讲解视频',
        author: '《创世战车》运营团队',
        release_time: '2024-07-29',
      },
      {
        id: 48,
        cover: 'https://coresource.zhanhuo.com/image/2.17/jiaoxue4.png',
        source: 'https://coresource.zhanhuo.com/video/2.17/jiaoxue4.mp4',
        desc: '保姆教学第四期【创世战车】武器种类及功能介绍（上）',
        author: '《创世战车》运营团队',
        release_time: '2024-08-12',
      },
      {
        id: 49,
        cover: 'https://coresource.zhanhuo.com/image/2.21/pv.png',
        source: 'https://coresource.zhanhuo.com/video/2.21/pv.mp4',
        desc: '《创世战车》全新版本“冰与火之歌”',
        author: '《创世战车》运营团队',
        release_time: '2024-11-28',
      },
    ]
  },
  // {
  //   id: 6,
  //   title: "萌新教学",
  //   list: []
  // }, 
  // {
  //   id: 7,
  //   title: "高手进阶",
  //   list: []
  // }, 
  {
    id: 8,
    title: "创意搭配",
    list: [{
      id: 9,
      cover: require('@/assets/images/video_page/video_img04/zchkj.png'),
      source: 'https://coresource.zhanhuo.com/video/crossout_bj/chaoshou_cz.mp4',
      desc: '《创世战车》创意搭配宣传',
      author: '《创世战车》运营团队',
      release_time: '2022-09-21',
    }]
  }
]
export default data